// ============================================================================
// MÓDULO 7 - READING FINAL
// ============================================================================
// 5 Sets temáticos × 12 preguntas = 60 preguntas totales
// Integra TODAS las 12 unidades del módulo
// Passages de ~40 palabras intercalados
// Progresión: General → Específico → Complete Integration
// ============================================================================

export const M7_READING_PRACTICE = {
  id: "m7-final-reading",
  title: "Módulo 7 - Final Reading Practice",
  
  sets: [
    // ========================================================================
    // SET 1: A TYPICAL WEEK (Units 1, 2, 5, 9)
    // ========================================================================
    {
      id: "m7-reading-s1",
      title: "Reading Set 1: A Typical Week 📅",
      context: `**Story: Sarah's Weekly Routine**

Integration: Daily routines + Hobbies + Sports + Preferences`,
      
      questions: [
        // ==================================================================
        // PASSAGE 1: Morning Routine (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `**My Typical Week**

I usually wake up at 7 AM on weekdays. I never skip breakfast because it's the most important meal of the day. After eating, I always brush my teeth and get dressed. Then I leave for work at 8:30 AM sharp - I hate being late!`
        },
        {
          type: "mc",
          q: "How often does Sarah skip breakfast?",
          options: [
            "Never",
            "Sometimes",
            "Always"
          ],
          a: "Never",
          successtip: "✓ FREQUENCY!\n'Never' = 0%! She always eats breakfast! Unit 1: Time expressions! ⏰"
        },
        {
          type: "blank",
          q: "Sarah leaves for work ___ 8:30 AM. (preposition for exact time)",
          a: "at",
          accept: { ignoreCase: true },
          successtip: "✓ AT FOR TIME!\n'At' + exact time! Unit 1: Time prepositions! ⏰"
        },
        {
          type: "mc",
          q: "Sarah ___ being late. (strong dislike)",
          options: [
            "hates (strong)",
            "likes",
            "loves"
          ],
          a: "hates (strong)",
          successtip: "✓ HATE!\nHate = strong dislike! Unit 9: Likes & Dislikes! 👎"
        },

        // ==================================================================
        // PASSAGE 2: Evening Hobbies (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `In the evenings, I enjoy reading novels - I'm really into mystery stories. On Tuesdays and Thursdays, I play tennis at the local sports club. I'm keen on staying active! On Fridays, I usually go cycling with friends. Exercise makes me feel energized!`
        },
        {
          type: "mc",
          q: "What phrase shows strong interest in mystery stories?",
          options: [
            "I'm really into (strong interest)",
            "I hate",
            "I dislike"
          ],
          a: "I'm really into (strong interest)",
          successtip: "✓ BE INTO!\n'Be into' = strong interest! Unit 9: Expressing preferences! 📚"
        },
        {
          type: "blank",
          q: "Sarah ___ tennis on Tuesdays and Thursdays. (sport verb)",
          a: "plays",
          accept: { ignoreCase: true },
          successtip: "✓ PLAY TENNIS!\n'Play' tennis! Unit 5: Sports verbs! 🎾"
        },
        {
          type: "mc",
          q: "Sarah is ___ staying active. (shows enthusiasm)",
          options: [
            "keen on",
            "tired of",
            "bored with"
          ],
          a: "keen on",
          successtip: "✓ KEEN ON!\n'Keen on' = enthusiastic about! Unit 9: Preferences! 💪"
        },
        {
          type: "order",
          q: "Traduce el hobby: 'Go cycling' = ___",
          a: "Andar en bicicleta",
          successtip: "✓ GO CYCLING!\nGo + -ing = activity! Unit 2: Hobbies! 🚴"
        },

        // ==================================================================
        // PASSAGE 3: Weekend Activities (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `On weekends, I prefer relaxing at home. I'm fond of cooking - especially Italian food! On Saturday mornings, I often go jogging in the park. In the afternoon, I might do yoga or go swimming at the gym. Sundays are for resting!`
        },
        {
          type: "mc",
          q: "Sarah ___ relaxing at home. (choice/preference)",
          options: [
            "prefers (choice)",
            "hates",
            "never does"
          ],
          a: "prefers (choice)",
          successtip: "✓ PREFER!\nPrefer = choose one thing over another! Unit 9: Preferences! 🏠"
        },
        {
          type: "blank",
          q: "Sarah is ___ ___ cooking. (likes it)",
          a: "fond of",
          accept: { ignoreCase: true },
          successtip: "✓ FOND OF!\n'Fond of' = likes! Unit 9: Expressing likes! ❤️"
        },
        {
          type: "mc",
          q: "What two exercises does Sarah do at the gym?",
          options: [
            "Yoga and swimming",
            "Only tennis",
            "Only jogging"
          ],
          a: "Yoga and swimming",
          successtip: "✓ GYM ACTIVITIES!\nDo yoga, go swimming! Unit 5: Exercise vocabulary! 🧘‍♀️🏊"
        },
        {
          type: "mc",
          q: "How often does Sarah go jogging?",
          options: [
            "Often (frequently)",
            "Never",
            "Always"
          ],
          a: "Often (frequently)",
          successtip: "✓ OFTEN!\n'Often' = frequently, around 70%! Unit 1: Frequency adverbs! 🏃"
        }
      ]
    },

    // ========================================================================
    // SET 2: GOING SHOPPING (Units 4, 6, 8, 10)
    // ========================================================================
    {
      id: "m7-reading-s2",
      title: "Reading Set 2: Shopping Trip with Family 🛒",
      context: `**Story: Family Shopping Day**

Integration: Food + Money + Comparing + Family relationships`,
      
      questions: [
        // ==================================================================
        // PASSAGE 1: Planning (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `Last Saturday, my mother-in-law and I went shopping together. We needed ingredients for Sunday's family dinner. I prefer shopping at the farmers market - it's fresher than the supermarket, even though it's slightly more expensive. My mother-in-law prefers saving money though!`
        },
        {
          type: "mc",
          q: "Who went shopping together?",
          options: [
            "The narrator and mother-in-law",
            "Only the narrator",
            "The entire family"
          ],
          a: "The narrator and mother-in-law",
          successtip: "✓ MOTHER-IN-LAW!\nMother-in-law = spouse's mother! Unit 10: Family vocabulary! 👪"
        },
        {
          type: "blank",
          q: "The farmers market is ___ than the supermarket. (quality)",
          a: "fresher",
          accept: { ignoreCase: true },
          successtip: "✓ COMPARATIVE!\nFresher = more fresh! Unit 8: Comparing! Fresh → fresher! 🥬"
        },
        {
          type: "mc",
          q: "The farmers market is ___ expensive.",
          options: [
            "more (than supermarket)",
            "less",
            "not"
          ],
          a: "more (than supermarket)",
          successtip: "✓ MORE EXPENSIVE!\nMore expensive = costs more! Unit 8: Comparatives! 💰"
        },

        // ==================================================================
        // PASSAGE 2: At the Market (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `At the market, we bought fresh vegetables - tomatoes, onions, and peppers. I also got chicken breast for the main dish. The meat was much better quality than frozen meat. We spent £45 in total - quite reasonable! I paid by credit card.`
        },
        {
          type: "mc",
          q: "What vegetables did they buy?",
          options: [
            "Tomatoes, onions, peppers",
            "Only chicken",
            "Only fruit"
          ],
          a: "Tomatoes, onions, peppers",
          successtip: "✓ VEGETABLES!\nAll vegetables vocabulary! Unit 4: Food vocab! 🍅🧅"
        },
        {
          type: "blank",
          q: "They bought chicken ___ for the main dish. (part of chicken)",
          a: "breast",
          accept: { ignoreCase: true },
          successtip: "✓ CHICKEN BREAST!\nChicken breast = pechuga! Unit 4: Meat vocabulary! 🍗"
        },
        {
          type: "mc",
          q: "The fresh meat was ___ quality than frozen.",
          options: [
            "much better (big difference)",
            "worse",
            "the same"
          ],
          a: "much better (big difference)",
          successtip: "✓ MUCH BETTER!\n'Much' intensifies comparison! Unit 8: Comparing quality! 🥩"
        },
        {
          type: "order",
          q: "How much did they spend? They ___ £45 ___.",
          a: "spent, in total",
          successtip: "✓ SPEND!\nSpend + money! Unit 6: Money verbs! 💷"
        },
        {
          type: "blank",
          q: "They paid by ___ ___. (payment method, not cash)",
          a: "credit card",
          accept: { ignoreCase: true },
          successtip: "✓ CREDIT CARD!\nPay by credit card! Unit 6: Payment methods! 💳"
        },

        // ==================================================================
        // PASSAGE 3: Supermarket (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `Then we went to the supermarket for other items. The supermarket is cheaper for packaged goods. I bought pasta, rice, olive oil, and some snacks. The total was £28. My mother-in-law insisted on paying this time - she's very generous!`
        },
        {
          type: "mc",
          q: "For packaged goods, the supermarket is:",
          options: [
            "Cheaper (less expensive)",
            "More expensive",
            "The same price"
          ],
          a: "Cheaper (less expensive)",
          successtip: "✓ CHEAPER!\nCheaper = less expensive! Unit 8: Comparing prices! 💰"
        },
        {
          type: "blank",
          q: "The narrator bought pasta, rice, ___ ___, and snacks. (cooking oil)",
          a: "olive oil",
          accept: { ignoreCase: true },
          successtip: "✓ OLIVE OIL!\nOlive oil = aceite de oliva! Unit 4: Cooking ingredients! 🫒"
        },
        {
          type: "mc",
          q: "Who paid at the supermarket?",
          options: [
            "Mother-in-law",
            "Narrator",
            "They split it"
          ],
          a: "Mother-in-law",
          successtip: "✓ GENEROUS!\nShe insisted on paying = generous! Unit 10: Family interaction! 👵💝"
        },
        {
          type: "mc",
          q: "Total spent: Market (£45) + Supermarket (£28) = ?",
          options: [
            "£73 total",
            "£45",
            "£28"
          ],
          a: "£73 total",
          successtip: "✓ TOTAL COST!\n45 + 28 = 73! Unit 6: Money calculations! 💷"
        }
      ]
    },

    // ========================================================================
    // SET 3: CITY LIFE & EDUCATION (Units 7, 8, 11)
    // ========================================================================
    {
      id: "m7-reading-s3",
      title: "Reading Set 3: Moving to a New City 🏙️",
      context: `**Story: Student Life in a New City**

Integration: City/Phrasal verbs + Comparing cities + Education`,
      
      questions: [
        // ==================================================================
        // PASSAGE 1: The Move (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `I grew up in a small village, but last year I moved to London to study medicine at university. At first, the city was overwhelming! London is much bigger and noisier than my hometown. However, it's also more exciting - there's always something to do!`
        },
        {
          type: "mc",
          q: "What does 'grew up' mean?",
          options: [
            "Spent childhood (phrasal verb)",
            "Became taller",
            "Moved away"
          ],
          a: "Spent childhood (phrasal verb)",
          successtip: "✓ GROW UP!\n'Grow up' = pasar la infancia! Unit 7: Phrasal verbs! 👶➡️👨"
        },
        {
          type: "blank",
          q: "The narrator studies ___ at university. (subject)",
          a: "medicine",
          accept: { ignoreCase: true },
          successtip: "✓ MEDICINE!\nMedicine = medical studies! Unit 11: Academic subjects! 🏥"
        },
        {
          type: "mc",
          q: "London is ___ than the village.",
          options: [
            "much bigger and noisier (two comparatives)",
            "smaller",
            "quieter"
          ],
          a: "much bigger and noisier (two comparatives)",
          successtip: "✓ DOUBLE COMPARATIVE!\nBigger + noisier! Unit 8: Comparing places! 🏙️"
        },
        {
          type: "blank",
          q: "London is also more ___. (positive quality)",
          a: "exciting",
          accept: { ignoreCase: true },
          successtip: "✓ MORE EXCITING!\nLong adjective: more + exciting! Unit 8: Comparatives! 🎉"
        },

        // ==================================================================
        // PASSAGE 2: University Life (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `University is challenging but successful so far! I attend lectures every day and study in the library most evenings. My textbooks are expensive, but I found out that I can borrow them from the library instead. That saves money! I'm hopeful about passing my exams.`
        },
        {
          type: "mc",
          q: "The narrator attends ___ every day. (university classes)",
          options: [
            "lectures",
            "schools",
            "offices"
          ],
          a: "lectures",
          successtip: "✓ LECTURES!\nLectures = university classes! Unit 11: Academic vocabulary! 🎓"
        },
        {
          type: "blank",
          q: "The narrator borrows ___ from the library. (books for studying)",
          a: "textbooks",
          accept: { ignoreCase: true },
          successtip: "✓ TEXTBOOKS!\nTextbooks = libros de texto! Unit 11: School supplies! 📚"
        },
        {
          type: "mc",
          q: "'Found out' means:",
          options: [
            "Discovered (phrasal verb)",
            "Lost something",
            "Went outside"
          ],
          a: "Discovered (phrasal verb)",
          successtip: "✓ FIND OUT!\n'Find out' = descubrir/enterarse! Unit 7: Phrasal verbs! 🔍"
        },
        {
          type: "order",
          q: "The narrator is ___ about passing. (suffix -ful = full of hope)",
          a: "hopeful",
          successtip: "✓ HOPEFUL!\nHopeFUL = full of hope! Unit 11: Word formation (-ful)! ✨"
        },

        // ==================================================================
        // PASSAGE 3: City Exploration (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `On weekends, I explore the city. London has more museums and theaters than my village had! I often run into classmates at cafés - it's a small world! The public transport is wonderful here. I've given up driving because the Underground is faster and cheaper.`
        },
        {
          type: "mc",
          q: "London has ___ museums and theaters.",
          options: [
            "more (than village)",
            "fewer",
            "no"
          ],
          a: "more (than village)",
          successtip: "✓ MORE!\nMore = comparative of 'many'! Unit 8: Comparing quantities! 🏛️"
        },
        {
          type: "blank",
          q: "'Run into' means ___ someone by chance. (phrasal verb)",
          a: "meet",
          accept: { ignoreCase: true, alts: ["encounter", "see"] },
          successtip: "✓ RUN INTO!\n'Run into' = encontrarse con (casual)! Unit 7: Phrasal verbs! 👋"
        },
        {
          type: "mc",
          q: "The narrator has ___ driving. (stopped completely - phrasal verb)",
          options: [
            "given up",
            "started",
            "continued"
          ],
          a: "given up",
          successtip: "✓ GIVE UP!\n'Give up' = dejar/abandonar! Unit 7: Phrasal verbs! 🚫🚗"
        },
        {
          type: "mc",
          q: "The Underground is ___ and ___ than driving.",
          options: [
            "faster and cheaper (two comparatives)",
            "slower and more expensive",
            "the same"
          ],
          a: "faster and cheaper (two comparatives)",
          successtip: "✓ DOUBLE COMPARISON!\nFaster + cheaper! Unit 8: Comparing advantages! 🚇💰"
        }
      ]
    },

    // ========================================================================
    // SET 4: PAST EXPERIENCES (Units 3, 10, 12)
    // ========================================================================
    {
      id: "m7-reading-s4",
      title: "Reading Set 4: Memorable Experiences 📸",
      context: `**Story: Life Experiences**

Integration: Present perfect vs Past + Childhood + Travel`,
      
      questions: [
        // ==================================================================
        // PASSAGE 1: Childhood (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `I've always loved traveling since I was a toddler. When I was young, my parents fed me stories about different countries. We lived in a small house with my sister, brother, and our grandparents. My grandfather led us on nature walks every Sunday - those memories are precious!`
        },
        {
          type: "mc",
          q: "'I've always loved' - which tense?",
          options: [
            "Present perfect (experience from past until now)",
            "Past simple",
            "Future"
          ],
          a: "Present perfect (experience from past until now)",
          successtip: "✓ PRESENT PERFECT!\n'Have + past participle' = experience! Unit 3: Present perfect! ✅"
        },
        {
          type: "blank",
          q: "A child aged 1-3 years old is called a ___.",
          a: "toddler",
          accept: { ignoreCase: true },
          successtip: "✓ TODDLER!\nToddler = 1-3 years! Unit 10: Life stages! 👶"
        },
        {
          type: "mc",
          q: "Past tense of 'feed': My parents ___ me stories.",
          options: [
            "fed (irregular)",
            "feeded",
            "feeds"
          ],
          a: "fed (irregular)",
          successtip: "✓ FED!\nFeed → Fed → Fed! Irregular! Unit 10: Past verbs! 🍽️"
        },
        {
          type: "order",
          q: "Past tense of 'lead': Grandfather ___ us on walks. (irregular)",
          a: "led",
          successtip: "✓ LED!\nLead → Led → Led! Irregular! Unit 10: Past verbs! 🚶"
        },

        // ==================================================================
        // PASSAGE 2: Travel Experiences (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `I've visited fifteen countries so far. Last summer, I flew to Japan for two weeks. I packed my bags carefully and set off on the journey excitedly. At Tokyo airport, I checked in my luggage and boarded the plane. The flight was long but comfortable!`
        },
        {
          type: "mc",
          q: "'I've visited' vs 'I flew' - difference?",
          options: [
            "'I've visited' = present perfect (experience, no specific time). 'I flew' = past simple (specific: last summer)",
            "They're the same",
            "Both are future"
          ],
          a: "'I've visited' = present perfect (experience, no specific time). 'I flew' = past simple (specific: last summer)",
          successtip: "✓ KEY DIFFERENCE!\nPresent perfect = experience. Past simple = specific time! Unit 3: Critical! ⏰"
        },
        {
          type: "blank",
          q: "The narrator ___ bags before traveling. (preparation)",
          a: "packed",
          accept: { ignoreCase: true },
          successtip: "✓ PACKED!\nPack bags = empacar! Unit 12: Travel collocations! 🧳"
        },
        {
          type: "mc",
          q: "'Set off' means:",
          options: [
            "Begin a journey",
            "Finish a journey",
            "Cancel a journey"
          ],
          a: "Begin a journey",
          successtip: "✓ SET OFF!\n'Set off' = iniciar viaje! Unit 12: Natural phrases! 🚀"
        },
        {
          type: "order",
          q: "At the airport, the narrator 'checked ___ luggage' and '___ the plane'.",
          a: "in, boarded",
          successtip: "✓ AIRPORT COLLOCATIONS!\nCheck in + board! Unit 12: Natural combinations! ✈️"
        },

        // ==================================================================
        // PASSAGE 3: Recent vs Past (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `Have you ever traveled alone? I did it for the first time last year. It was scary initially, but I've learned so much from that experience! I've become more confident since then. I took trains, buses, and even rode a bicycle through Amsterdam!`
        },
        {
          type: "mc",
          q: "'Have you ever traveled' - why present perfect?",
          options: [
            "Asking about life experience (no specific time mentioned)",
            "Asking about future",
            "Asking about tomorrow"
          ],
          a: "Asking about life experience (no specific time mentioned)",
          successtip: "✓ EVER!\n'Ever' with present perfect = life experience question! Unit 3: Usage! 🌍"
        },
        {
          type: "blank",
          q: "'I ___ it last year' - which tense? (specific time = past simple)",
          a: "did",
          accept: { ignoreCase: true },
          successtip: "✓ PAST SIMPLE!\nLast year = specific time! Must use past simple! Unit 3: Rules! 📅"
        },
        {
          type: "mc",
          q: "'I've learned' vs 'I've become' - which tense?",
          options: [
            "Present perfect (changes from past until now)",
            "Past simple",
            "Future"
          ],
          a: "Present perfect (changes from past until now)",
          successtip: "✓ PRESENT PERFECT CHANGE!\n'Have become/learned' = change over time! Unit 3: Usage! 📈"
        },
        {
          type: "mc",
          q: "Which vehicles did they use? (3 types)",
          options: [
            "Trains, buses, bicycle",
            "Only plane",
            "Only car"
          ],
          a: "Trains, buses, bicycle",
          successtip: "✓ TRANSPORT MIX!\nTook trains/buses + rode bicycle! Unit 12: Vehicles & collocations! 🚆🚌🚴"
        }
      ]
    },

    // ========================================================================
    // SET 5: PLANNING A BIG TRIP - FINAL INTEGRATION (All Units!)
    // ========================================================================
    {
      id: "m7-reading-s5",
      title: "Reading Set 5: The Perfect Vacation 🌍✨",
      context: `**FINAL INTEGRATION STORY**

ALL 12 Units integrated naturally in one complete narrative!`,
      
      questions: [
        // ==================================================================
        // PASSAGE 1: Planning (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `My cousin and I have been planning our dream vacation for months! We've always wanted to visit Italy. We prefer going in September because it's cheaper than July or August, and the weather is still wonderful. I'm really into Italian culture, especially the food and history!`
        },
        {
          type: "mc",
          q: "'Have been planning' - which tense?",
          options: [
            "Present perfect continuous (action started in past, continues now)",
            "Past simple",
            "Future simple"
          ],
          a: "Present perfect continuous (action started in past, continues now)",
          successtip: "✓ PRESENT PERFECT CONTINUOUS!\n'Have been + -ing' = ongoing action! Unit 3: Advanced! 📅"
        },
        {
          type: "blank",
          q: "Your aunt/uncle's child is your ___.",
          a: "cousin",
          accept: { ignoreCase: true },
          successtip: "✓ COUSIN!\nCousin = primo/a! Unit 10: Family vocabulary! 👥"
        },
        {
          type: "mc",
          q: "September is ___ than July or August.",
          options: [
            "cheaper (less expensive)",
            "more expensive",
            "the same price"
          ],
          a: "cheaper (less expensive)",
          successtip: "✓ CHEAPER!\nComparative! Unit 8: Comparing prices! 💰"
        },
        {
          type: "order",
          q: "The narrator is ___ ___ Italian culture. (strong interest phrase)",
          a: "really into",
          successtip: "✓ REALLY INTO!\n'Really into' = strong interest! Unit 9: Preferences! ❤️"
        },

        // ==================================================================
        // PASSAGE 2: Preparation & Travel (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `Last week, we set off on our journey! We woke up early and took a taxi to the airport. We arrived at the airport on time and checked in our luggage. After boarding the plane, we flew for two hours. I'm fond of flying - the views are amazing!`
        },
        {
          type: "mc",
          q: "'Last week' requires which tense?",
          options: [
            "Past simple (specific time in past)",
            "Present perfect",
            "Future"
          ],
          a: "Past simple (specific time in past)",
          successtip: "✓ PAST SIMPLE!\nSpecific time = past simple! Unit 3: Critical rule! ⏰"
        },
        {
          type: "blank",
          q: "Natural collocation: '___ up' early. (irregular past)",
          a: "woke",
          accept: { ignoreCase: true },
          successtip: "✓ WAKE UP!\nWake up = despertarse! Unit 1: Daily routines! ⏰"
        },
        {
          type: "mc",
          q: "They arrived ___ the airport. (correct preposition)",
          options: [
            "at (NOT 'to'!)",
            "to",
            "in"
          ],
          a: "at (NOT 'to'!)",
          successtip: "✓ ARRIVE AT!\n'Arrive AT' airport! Unit 12: Critical collocation! ✈️"
        },
        {
          type: "order",
          q: "Airport sequence: Arrived → ___ ___ → ___ → Flew",
          a: "checked in, boarded",
          successtip: "✓ AIRPORT PROCESS!\nCheck in luggage → board plane! Unit 12: Natural sequence! ✈️"
        },
        {
          type: "blank",
          q: "The narrator is ___ ___ flying. (likes it)",
          a: "fond of",
          accept: { ignoreCase: true },
          successtip: "✓ FOND OF!\n'Fond of' = likes! Unit 9: Expressing likes! ❤️"
        },

        // ==================================================================
        // PASSAGE 3: Arriving & Activities (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `We arrived at our hotel in Rome and checked in quickly. The hotel is much nicer than I expected - it's more modern and cleaner than the photos showed! In the evening, we went shopping at local markets. We bought fresh pasta, olive oil, and tomatoes to cook dinner!`
        },
        {
          type: "mc",
          q: "Hotel process: 'arrived at' → '___'",
          options: [
            "checked in (registered)",
            "packed bags",
            "flew"
          ],
          a: "checked in (registered)",
          successtip: "✓ CHECK IN!\nCheck into hotel = registrarse! Unit 12: Hotel collocations! 🏨"
        },
        {
          type: "blank",
          q: "The hotel is ___ and ___ than expected. (two comparatives)",
          a: "nicer, cleaner",
          accept: { ignoreCase: true, alts: ["more modern, cleaner", "nicer, more modern"] },
          successtip: "✓ DOUBLE COMPARATIVE!\nNicer + cleaner! Unit 8: Comparing quality! ✨"
        },
        {
          type: "mc",
          q: "They bought pasta, olive oil, and tomatoes - what for?",
          options: [
            "To cook dinner (ingredients)",
            "To throw away",
            "To sell"
          ],
          a: "To cook dinner (ingredients)",
          successtip: "✓ COOKING INGREDIENTS!\nPasta + olive oil + tomatoes! Unit 4: Food vocabulary! 🍝"
        },

        // ==================================================================
        // PASSAGE 4: Daily Activities (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `Every morning, we usually wake up at 8 AM and have breakfast at a café. Then we go sightseeing - we've visited the Colosseum, museums, and beautiful churches. We often go cycling through the city streets. I'm keen on exploring every neighborhood! Rome is more exciting than any city I've visited before!`
        },
        {
          type: "mc",
          q: "'Usually' indicates:",
          options: [
            "Frequency (often, around 80%)",
            "Never doing something",
            "Future plan"
          ],
          a: "Frequency (often, around 80%)",
          successtip: "✓ USUALLY!\nUsually = frequency adverb, ~80%! Unit 1: Time expressions! ⏰"
        },
        {
          type: "blank",
          q: "'We've visited' - which tense? (during this trip, no specific day)",
          a: "present perfect",
          accept: { ignoreCase: true },
          successtip: "✓ PRESENT PERFECT!\n'Have visited' = experience during trip! Unit 3: Usage! ✅"
        },
        {
          type: "mc",
          q: "Activity: 'go ___' (andar en bici)",
          options: [
            "cycling (go + -ing)",
            "cycle",
            "to cycle"
          ],
          a: "cycling (go + -ing)",
          successtip: "✓ GO CYCLING!\nGo + -ing = activity! Unit 2 & 12: Hobbies & transport! 🚴"
        },
        {
          type: "order",
          q: "The narrator is ___ ___ exploring. (enthusiastic about)",
          a: "keen on",
          successtip: "✓ KEEN ON!\nKeen on = enthusiastic! Unit 9: Strong interest! ⭐"
        },
        {
          type: "mc",
          q: "Rome is more exciting than ___ city visited before. (superlative idea)",
          options: [
            "any (the most exciting of all)",
            "no",
            "some"
          ],
          a: "any (the most exciting of all)",
          successtip: "✓ MORE...THAN ANY!\n'More than any' = superlative meaning! Unit 8: Comparing! 🏆"
        },

        // ==================================================================
        // PASSAGE 5: FINAL - Complete Integration (~40 words)
        // ==================================================================
        {
          type: "passage",
          passage: `This vacation has been wonderful! I've learned some Italian words at the library before the trip - it's been very useful! Tomorrow we'll take a train to Florence. We're unlikely to have time to visit Venice, but that's okay. We've already decided to come back next year! I'll definitely recommend this trip!`
        },
        {
          type: "mc",
          q: "'Has been' - which tense and why?",
          options: [
            "Present perfect (experience continues, trip not finished)",
            "Past simple",
            "Future"
          ],
          a: "Present perfect (experience continues, trip not finished)",
          successtip: "✓ PRESENT PERFECT!\nStill on vacation! Experience continues! Unit 3: Usage! ✅"
        },
        {
          type: "blank",
          q: "The narrator learned Italian at the ___. (place for studying/books)",
          a: "library",
          accept: { ignoreCase: true },
          successtip: "✓ LIBRARY!\nLibrary = biblioteca! Unit 11: Educational places! 📚"
        },
        {
          type: "mc",
          q: "Tomorrow they'll ___ a train. (collocation)",
          options: [
            "take",
            "drive",
            "ride"
          ],
          a: "take",
          successtip: "✓ TAKE A TRAIN!\n'Take' a train/bus/taxi! Unit 12: Transport collocations! 🚆"
        },
        {
          type: "order",
          q: "They're ___ to visit Venice. (prefix UN- = not likely)",
          a: "unlikely",
          successtip: "✓ UNLIKELY!\nUN- = not! Unlikely = improbable! Unit 11: Word formation! 🚫"
        },
        {
          type: "mc",
          q: "'We've decided' - which tense?",
          options: [
            "Present perfect (recent decision with present relevance)",
            "Past simple",
            "Future simple"
          ],
          a: "Present perfect (recent decision with present relevance)",
          successtip: "✓ PRESENT PERFECT DECISION!\n'Have decided' = recent decision! Unit 3: Perfect usage! ✅"
        },
        {
          type: "mc",
          q: "FINAL: This passage integrates how many units?",
          options: [
            "ALL 12 units (routines, hobbies, present perfect, food, sports, money, cities, comparing, preferences, family, education, travel)!",
            "Only 3 units",
            "Only 6 units"
          ],
          a: "ALL 12 units (routines, hobbies, present perfect, food, sports, money, cities, comparing, preferences, family, education, travel)!",
          successtip: "🎉 MÓDULO 7 READING COMPLETE! 🎉\n\n✅ ALL 12 UNITS INTEGRATED!\n\n1️⃣ Routines & Time: wake up, usually, at ✅\n2️⃣ Hobbies: go cycling, go sightseeing ✅\n3️⃣ Present Perfect vs Past: have been, last week, have visited ✅\n4️⃣ Food: pasta, olive oil, tomatoes, cooking ✅\n5️⃣ Sports: cycling, jogging, swimming, tennis ✅\n6️⃣ Money: cheaper, spent, paid ✅\n7️⃣ Phrasal Verbs: grow up, find out, run into, give up, wake up ✅\n8️⃣ Comparing: nicer, cheaper, more exciting, better ✅\n9️⃣ Preferences: prefer, fond of, keen on, really into, hate ✅\n🔟 Family: cousin, mother-in-law, toddler, grandfather ✅\n1️⃣1️⃣ Education: library, unlikely (word formation) ✅\n1️⃣2️⃣ Travel: packed, set off, arrived at, checked in, boarded, flew, take a train ✅\n\n🌟 NATURAL INTEGRATION!\n• 60 questions across 5 thematic sets ✅\n• All grammar, vocabulary, collocations ✅\n• Real-life scenarios ✅\n• Progressive difficulty ✅\n\nB1-B2 Module 7 Reading = MASTERED! 💪📖\n\nReady for Module Review! 🚀✨"
        }
      ]
    }
  ]
};
